"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUISITION_TYPE_MODES = exports.REQUISITION_TYPE_ALLOCATION_MODES = exports.REQUISITION_STATUSES = void 0;
var REQUISITION_TYPE_MODES = exports.REQUISITION_TYPE_MODES = ['BUDGET_FIXED_COSTS', 'BUDGET_COST_PER_UNIT', 'QUOTE', 'OPEN', 'NO_BUDGET_PURCHASING'];
var REQUISITION_TYPE_ALLOCATION_MODES = exports.REQUISITION_TYPE_ALLOCATION_MODES = ['NONE', 'ALLOCATION', 'COST_CENTER'];
var REQUISITION_STATUSES = exports.REQUISITION_STATUSES = ['DRAFT', 'ACTIVE', 'INACTIVE', 'DELETED'];